import { boot } from "@app/shared/boot";
import { App } from "./App";

boot(<App />);
